import { withStyles } from '@mui/styles';
import { Container } from '@mui/material';

export const StyledContainerFixed = withStyles({
  root: {
    position: 'fixed',
    minWidth: 600,
    width: '75% !important',
    height: '100%',
    top: 0,
    right: 0,
    display: 'flex !important',
    flexDirection: 'column',
    zIndex: 1101,
    backgroundColor: 'white',
    boxShadow: '0 1px 0 0 rgba(91, 101, 117, 0.15)',
  },
})(Container);

export const StyledContainer = withStyles({
  root: {
    position: 'absolute',
    minWidth: 600,
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    display: 'flex !important',
    flexDirection: 'column',
    zIndex: 1101,
    backgroundColor: 'white',
    boxShadow: '0 1px 0 0 rgba(91, 101, 117, 0.15)',
  },
})(Container);
